import type { ColorTheme } from "./resolve_site_color_theme";

// What the user picked; SYSTEM follows the device's light/dark setting.
export type ThemePreference = ColorTheme | "SYSTEM";

export const THEME_PREFERENCES: ThemePreference[] = ["LIGHT", "DARK", "SYSTEM"];

export const SYSTEM_DARK_QUERY = "(prefers-color-scheme: dark)";

export const parseThemePreference = (raw: unknown): ThemePreference =>
	THEME_PREFERENCES.includes(raw as ThemePreference) ? (raw as ThemePreference) : "LIGHT";

// The order a single theme button steps through.
export const nextThemePreference = (current: ThemePreference): ThemePreference =>
	THEME_PREFERENCES[(THEME_PREFERENCES.indexOf(current) + 1) % THEME_PREFERENCES.length];

export const resolveThemePreference = (
	preference: ThemePreference,
	isSystemDark: boolean,
): ColorTheme => {
	if (preference === "SYSTEM") return isSystemDark ? "DARK" : "LIGHT";
	return preference;
};

export const readThemePreference = (): ThemePreference => {
	try {
		return parseThemePreference(JSON.parse(localStorage.getItem("appTheme") ?? "null"));
	} catch {
		return "LIGHT";
	}
};

export const isSystemDarkNow = (): boolean => !!window.matchMedia?.(SYSTEM_DARK_QUERY).matches;
